const WorkExperience = [
    {
        id: 1,
        title: "Intern as Full Stack Developer",
        company: "Ardent Computech PVT LTD",
        yearsActive: "May 2024 - July 2024 ",
        information: [
            "Developed a full-featured College ERP system with separate modules for Admin, Student, and Faculty panels.",
            "Developed and managed a REST API using React and MongoDB to store data",
             "Created comprehensive reporting tools that generate visual insights and analytics for Admin and Faculty to monitor student performance, attendance .",
            "Developed responsive and dynamic front-end interfaces using React.js, Material-UI/Bootstrap."
           
            
        ],
    }  
   
];

export default WorkExperience;
